import { render, staticRenderFns } from "./locationTest.vue?vue&type=template&id=2c45a99d&scoped=true&"
import script from "./locationTest.vue?vue&type=script&lang=js&"
export * from "./locationTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c45a99d",
  null
  
)

export default component.exports